import { Site } from "shared/interfaces/Site";
import { isNationalUmbrellaSite } from "./nationals";

/**
 * Determines the correct color to use for a site when complementing the brand color - abyss
 * When a site's primary color is black, use their secondary color
 * This is a request by design. We don't want a black textured background
 * @param site The current site
 * @returns A string representing a hex color or undefined
 */

const BLACK_COLORS = ["000000", "000", "black"];

export const siteAccentColor = (site: Site): string | undefined => {
  if (BLACK_COLORS.includes(site.primaryColor)) {
    return `#${site.secondaryColor}`;
  }

  return !isNationalUmbrellaSite(site.friendlyName)
    ? `#${site.primaryColor}`
    : undefined;
};
